import { createGlobalStyle } from "styled-components"

const GlobalStyle = createGlobalStyle`
    body {
        margin: 0;
        font-family: ${(props) => props.theme.defaultFont};
        font-size: ${(props) => props.theme.fontSizes.md}px;
        overflow: hidden;
        color: ${(props) => props.theme.defaultTextColor};

        *::-webkit-scrollbar-track {
            background: ${(props) => props.theme.scrollbarTrack};
        }

        *::-webkit-scrollbar-thumb {
            border-radius: 0px;
            background: ${(props) => props.theme.scrollbarThumb};

            &:hover{
                background: ${(props) => props.theme.scrollbarThumbHover};
            }
        }

        *::-webkit-scrollbar {
            width: ${(props) => props.theme.scrollbarSize}px;
            height: ${(props) => props.theme.scrollbarSize}px;
        }

        a {
            color: ${(props) => props.theme.defaultLinkColor};
            text-decoration: none;

            &:hover {
                color: ${(props) => props.theme.defaultLinkHoverColor};
                text-decoration: underline;
            }
        }

        &.dragging * {
            user-select: none;
            cursor: grabbing !important;
        }
    }

    #root {
        height: 100%;
        width: 100%;
        position: absolute;
        overflow: hidden;
    }
`
export default GlobalStyle
